import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LucideAngularModule, Heart, Instagram, Facebook, Twitter } from 'lucide-angular';
import { environment } from '../../../environments/environment';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-footer',
  imports: [
    LucideAngularModule,CommonModule, RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  readonly heart = Heart;
  readonly instagram = Instagram;
  readonly facebook = Facebook;
  readonly twitter = Twitter;

  readonly logo = `${environment.API_ENDPOINT}/assets/logo.png`;


  // shopLinks = ['All Products', 'Ashwagandha', 'Shilajit', 'Herbal Teas', 'New Arrivals', 'Best Sellers'];
  shopLinks = ['All Products', 'Ashwagandha'];
  aboutLinks = [
    { title:'Our Story', link: '/our-story' },
    { title:'Sourcing', link: '/sourcing' },
    { title:'Sustainability', link: '/sustainability' },
    { title:'Careers', link: '/careers' },


  ];
  helpLinks = [
    { title:'Shipping & Delivery', link: '/shipping-and-delivery' },
    { title:'Refund & Cancellation', link: '/refund-and-cancellation' },
    { title:'Terms & Conditions', link: '/terms-and-conditions' },
    { title:'Privacy Policy', link: '/privacy-policy' },
    { title:'Contact Us', link: '/contact-us' },
  ];
}
